<template>
  <modal
    v-slot="{ data }"
    name="signIn"
    modal-style="compact"
    :display-header-title="false"
  >
    <sign-in
      :session-expired="data.sessionExpired"
      :on-success="data.onSuccess"
    />
  </modal>
</template>


<script>
  import SignIn from './sign-in/index.vue';

  export default {
    name: 'SignInModal',

    components: {
      SignIn
    }
  };
</script>
